export const isExistMarketType = (marketType, alreadyAddedMarketTypes) => {
    return alreadyAddedMarketTypes.findIndex(x => x.id === marketType.id) !== -1;
}

export const isExistMarketCatId = (marketCatId, marketType) => {
    return marketType.categories.findIndex(x => x.id === marketCatId) !== -1;
}